module.exports = __webpack_public_path__ + "static/media/13.98e32378.jpeg";